import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import styles from "../../styles/ArtworkDetail.module.css";
import { getPhotoById } from "../../lib/firebase/firestore";
import { Photo } from "../../types";

export const PhotoGalleryDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [photo, setPhoto] = useState<Photo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPhoto = async () => {
      if (!id) return;
      try {
        const data = await getPhotoById(id);
        setPhoto(data);
      } catch (error) {
        console.error("Failed to load photo:", error);
      } finally {
        setLoading(false);
      }
    };

    loadPhoto();
  }, [id]);

  if (loading) return <div>Loading photo...</div>;
  if (!photo) return <div>Photo not found</div>;

  return (
    <div className={styles.detailContainer}>
      <Link to="/photogallery" className={styles.backLink}>
        ← Back to Gallery
      </Link>
      <h1 className={styles.title}>{photo.title}</h1>
      <div className={styles.imageContainer}>
        <img src={photo.imageUrl} alt={photo.title} className={styles.image} />
      </div>
      <div className={styles.description}>
        {photo.description && <p>{photo.description}</p>}
        {photo.tags?.length > 0 && (
          <p>
            <strong>Tags:</strong> {photo.tags.join(", ")}
          </p>
        )}
        {photo.year && (
          <p>
            <strong>Year:</strong> {photo.year}
          </p>
        )}
      </div>
    </div>
  );
};
